import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { ButtonProps, EditButton } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../../core/security/SprintAccessRight";
import { getCiEditOnPremAssetContentPageHref } from "../../../../../AssetsRoutes";
import { useOnPremAssetDetails } from "../../../common/hooks/useOnPremAssetDetails";
import { isOnPremAssetDeprecated } from "../../../OnPremAssetDetails";

export type EditOnPremAssetContentButtonProps = ButtonProps;

export const EditOnPremAssetContentButton = (): JSX.Element => {
    const { assetId } = useParams<{ assetId: string }>();
    const { isLoading, data: assetDetails } = useOnPremAssetDetails();
    const history = useHistory();

    const moveToEditFileRecordContentPage = () => {
        const href = getCiEditOnPremAssetContentPageHref(assetId);
        history.push(href);
    };

    const isEditButtonDisabled = assetDetails && (isOnPremAssetDeprecated(assetDetails) || isLoading);

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.AssetsReadWrite]}>
            <EditButton
                onClick={moveToEditFileRecordContentPage}
                label="Edit"
                isLabeled
                testId="edit-content"
                disabled={isEditButtonDisabled}
            />
        </AuthorizationWrapper>
    );
};
